import React, { CSSProperties, ComponentProps } from 'react';
import { OptimizedImg } from '../OptimizedImg';

export const CenterCoverImg = ({
  style = {},
  src,
  alt = '网易瑶台',
  ...rest
}: {
  style?: CSSProperties;
  src: string;
  alt?: string;
} & ComponentProps<typeof OptimizedImg>) => {
  return (
    <OptimizedImg
      // @ts-ignore
      fetchpriority="high"
      alt={alt}
      src={src}
      style={{
        objectFit: 'cover',
        objectPosition: 'center',
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        width: '100%',
        height: '100%',
        ...style,
      }}
      {...rest}
    />
  );
};
